import {
  AREAPLAN_EDIT,
  AREAPLAN_VIEW,
  BULLETIN_BOARD_ACCESS,
  BULLETIN_BOARD_EDIT_ALL,
  BULLETIN_BOARD_SEND,
  BULLETIN_CREATE_EDIT_OWN,
  COMPETENCIES_VIEW_OTHER_USER_COMPETENCIES,
  CUSTOMER_REGISTRY_ACCESS,
  DEFECTS_DEFECT_LISTS_ACCESS,
  DEFECTS_DEFECT_LISTS_CREATE,
  DEFECTS_DEFECT_LISTS_VIEW,
  DEFECTS_DEFECTS_EDIT,
  EDIT_OTHER_USERS_RECORDS,
  EDIT_PERMISSIONS_OF_PROJECT,
  EXPENSE_TRACKING_ACCESS,
  FILINGS_MANAGE,
  FIRESTOP_DOCUMENTATION_ACCESS,
  FORMS_ACCESS,
  FORMS_AUTOMATION_MANAGE,
  FORMS_CREATE_EDIT_OWN,
  FORMS_DELETE,
  FORMS_EDIT_ALL,
  FORMS_MANAGE_TEMPLATES,
  FORMS_ORIENTATION_FORMS_MANAGE,
  FORMS_SEND,
  GALLERY_ACCESS,
  GALLERY_ADD_PICTURES_TO_ROOT,
  GALLERY_MANAGE_FLOORPLANS,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  MANAGE_COMPANY_RESOURCES,
  ORGANIZATION_CHART_EMPLOYEE_INFO_VIEW,
  ORGANIZATION_CHART_MANAGE_ORGANIZATIONS,
  ORGANIZATION_CHART_VIEW,
  ORIENTATION_QUIZ_IGNORE_ORIENTATION_REQUIREMENT,
  ORIENTATION_QUIZ_MANAGE,
  PROJECT_APPROVALS_MANAGE,
  PROJECT_BANK_ACCESS,
  PROJECT_BANK_DELETE,
  PROJECT_BANK_DELETE_OWN,
  PROJECT_BANK_EDIT,
  PROJECT_BANK_EDIT_OWN,
  PROJECT_BANK_MOVE_ANY,
  PROJECT_BANK_MOVE_OWN,
  PROJECT_BANK_PRIVATE_FOLDER_ACCESS,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_MANAGE,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_VIEW,
  PROJECT_CHAT_ACCESS,
  PROJECT_CHAT_CREATE_INVITE_LINK,
  PROJECT_CHAT_RECORD_VIDEO_CHAT,
  PROJECT_CHAT_VIEW_RECORDINGS,
  PROJECT_CREATE,
  PROJECT_EDIT,
  PROJECT_EMAIL_READ,
  PROJECT_EMAIL_SEE_READ_BY_OTHERS,
  PROJECT_EMAIL_SEND,
  PROJECT_MAP_ACCESS,
  PROJECT_STATUS_EDIT,
  PROJECT_TIMELINES_EDIT,
  PROJECT_TIMELINES_VIEW,
  PROJECTS_OWN_ARCHIVED_PROJECTS_VIEW,
  PROJECTS_OWN_AUTOMATIC_JOIN,
  RECORDS_ABSENCE_CREATE,
  RECORDS_ALLOW_MULTIPLE_CLOCK_IN_OWN_PROJECTS,
  RECORDS_APPROVE,
  RECORDS_CHECK_BILLED_TIMES,
  RECORDS_CHECK_CLOCKED_TIMES,
  RECORDS_CREATE,
  RECORDS_CREATE_OTHER_USERS_RECORDS,
  RECORDS_EDIT_OWN_RECORDS,
  RECORDS_SEND_TO_APPROVAL,
  RECORDS_VIEW_OTHER_USERS_RECORDS_DETAILED_INFORMATION,
  RENOLOG_ACCESS,
  RENOLOG_MANAGE,
  RENOLOG_ORDER,
  RENOLOG_SHARE_ACCESS,
  REPORTS_GENERATE_EMPLOYEE_REPORT,
  REPORTS_GENERATE_ORIENTATION_REPORT,
  REPORTS_GENERATE_PROJECT_LIST_REPORT,
  RESOURCES_ADD_EMPLOYEES_TO_PROJECTS,
  RESOURCES_COMPETENCIES_MANAGE,
  RESOURCES_EDIT_SALARIES,
  SALARIES_TRANSFER_SEND,
  SALARIES_TYPES_EDIT,
  SUBCONTRACTORS_RECORDS_VIEW,
  VIEW_OTHER_RESOURCES,
  VIEW_OTHER_USERS_RECORDS,
  VIEW_SUBPROJECTS,
  WORK_CALENDAR_ACCESS,
  WORK_CALENDAR_EDIT_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
} from './permissions';

export const EMPLOYER_TOGGLABLE_PERMISSIONS = [
  RECORDS_ALLOW_MULTIPLE_CLOCK_IN_OWN_PROJECTS,
  PROJECTS_OWN_AUTOMATIC_JOIN,
  PROJECTS_OWN_ARCHIVED_PROJECTS_VIEW,
  SUBCONTRACTORS_RECORDS_VIEW,
  RESOURCES_EDIT_SALARIES,
  RESOURCES_COMPETENCIES_MANAGE,
  RESOURCES_ADD_EMPLOYEES_TO_PROJECTS,
  CUSTOMER_REGISTRY_ACCESS,
  SALARIES_TRANSFER_SEND,
  SALARIES_TYPES_EDIT,
  GALLERY_ADD_PICTURES_TO_ROOT,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
  WORK_CALENDAR_EDIT_ALL_OWN_BUSINESS_RECORDS,
];

export const PROJECT_TOGGLABLE_PERMISSIONS = [
  VIEW_OTHER_RESOURCES,
  MANAGE_COMPANY_RESOURCES,
  RECORDS_EDIT_OWN_RECORDS,
  EDIT_OTHER_USERS_RECORDS,
  VIEW_OTHER_USERS_RECORDS,
  RECORDS_VIEW_OTHER_USERS_RECORDS_DETAILED_INFORMATION,
  RECORDS_CREATE_OTHER_USERS_RECORDS,
  EDIT_PERMISSIONS_OF_PROJECT,
  BULLETIN_BOARD_ACCESS,
  BULLETIN_BOARD_EDIT_ALL,
  BULLETIN_CREATE_EDIT_OWN,
  BULLETIN_BOARD_SEND,
  FILINGS_MANAGE,
  FORMS_ACCESS,
  FORMS_CREATE_EDIT_OWN,
  FORMS_EDIT_ALL,
  FORMS_DELETE,
  FORMS_SEND,
  FORMS_MANAGE_TEMPLATES,
  FORMS_ORIENTATION_FORMS_MANAGE,
  FORMS_AUTOMATION_MANAGE,
  GALLERY_ACCESS,
  GALLERY_VIEW_OTHER_USERS_IMAGES,
  GALLERY_VIEW_MEDIA_ADDER_INFO,
  GALLERY_MANAGE_FLOORPLANS,
  PROJECT_BANK_ACCESS,
  PROJECT_BANK_DELETE,
  PROJECT_BANK_DELETE_OWN,
  PROJECT_BANK_EDIT,
  PROJECT_BANK_EDIT_OWN,
  PROJECT_BANK_MOVE_ANY,
  PROJECT_BANK_MOVE_OWN,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_VIEW,
  PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_MANAGE,
  PROJECT_BANK_PRIVATE_FOLDER_ACCESS,
  PROJECT_CREATE,
  PROJECT_EDIT,
  PROJECT_STATUS_EDIT,
  PROJECT_MAP_ACCESS,
  EXPENSE_TRACKING_ACCESS,
  VIEW_SUBPROJECTS,
  RECORDS_CHECK_CLOCKED_TIMES,
  RECORDS_CHECK_BILLED_TIMES,
  RECORDS_APPROVE,
  RECORDS_SEND_TO_APPROVAL,
  RECORDS_ABSENCE_CREATE,
  PROJECT_APPROVALS_MANAGE,
  PROJECT_TIMELINES_EDIT,
  PROJECT_TIMELINES_VIEW,
  ORIENTATION_QUIZ_MANAGE,
  ORIENTATION_QUIZ_IGNORE_ORIENTATION_REQUIREMENT,
  COMPETENCIES_VIEW_OTHER_USER_COMPETENCIES,
  REPORTS_GENERATE_ORIENTATION_REPORT,
  REPORTS_GENERATE_EMPLOYEE_REPORT,
  REPORTS_GENERATE_PROJECT_LIST_REPORT,
  DEFECTS_DEFECT_LISTS_ACCESS,
  DEFECTS_DEFECT_LISTS_VIEW,
  DEFECTS_DEFECT_LISTS_CREATE,
  DEFECTS_DEFECTS_EDIT,
  RECORDS_CREATE,
  AREAPLAN_VIEW,
  AREAPLAN_EDIT,
  PROJECT_EMAIL_READ,
  PROJECT_EMAIL_SEND,
  PROJECT_EMAIL_SEE_READ_BY_OTHERS,
  PROJECT_CHAT_ACCESS,
  PROJECT_CHAT_RECORD_VIDEO_CHAT,
  PROJECT_CHAT_VIEW_RECORDINGS,
  PROJECT_CHAT_CREATE_INVITE_LINK,
  ORGANIZATION_CHART_VIEW,
  ORGANIZATION_CHART_MANAGE_ORGANIZATIONS,
  ORGANIZATION_CHART_EMPLOYEE_INFO_VIEW,
  WORK_CALENDAR_ACCESS,
  RENOLOG_ACCESS,
  RENOLOG_ORDER,
  RENOLOG_MANAGE,
  RENOLOG_SHARE_ACCESS,
  FIRESTOP_DOCUMENTATION_ACCESS,
];
